// formatPrice.ts
// Utility to format price with dynamic precision based on value

export function formatPrice(price: number): string {
  let minimumFractionDigits = 2;
  let maximumFractionDigits = 6;

  if (price >= 10000) {
    minimumFractionDigits = 1;
    maximumFractionDigits = 1;
  } else if (price >= 500) {
    minimumFractionDigits = 2;
    maximumFractionDigits = 2;
  } else if (price >= 100) {
    minimumFractionDigits = 3;
    maximumFractionDigits = 3;
  } else if (price < 1) {
    minimumFractionDigits = 4;
    maximumFractionDigits = 6;
  }

  return price.toLocaleString(undefined, {
    minimumFractionDigits,
    maximumFractionDigits,
  });
}
